import { SVGIcon } from "@progress/kendo-svg-icons";

export const submittalsIcon = {
    name: 'submittalsIcon',
    content: `<g transform="scale(16)">
                <path d="M15.5,14.24l-4.157-4.157l0.707-0.707l2.95,2.95V3h1v9.326l2.95-2.95l0.707,0.707L15.5,14.24z M29,14v9c0,0.553-0.447,1-1,1  H3c-0.552,0-1-0.447-1-1v-9c0-0.553,0.448-1,1-1h5c0.409,0,0.776,0.249,0.928,0.629L10.677,18h9.646l1.749-4.371  C22.224,13.249,22.591,13,23,13h5C28.553,13,29,13.447,29,14z M28,14h-5l-2,5H10l-2-5H3v9h25V14z"/>
              </g>`,
    viewBox: "0 0 512 512"
  };